'use client';

type Props = {
  message?: string;
  variant?: 'inline' | 'banner';
};

export function FormError({ message, variant = 'inline' }: Props) {
  if (!message) return null;

  if (variant === 'banner') {
    return (
      <div
        role="alert"
        className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-700"
      >
        {message}
      </div>
    );
  }

  return <p className="mt-1 text-xs text-red-500">{message}</p>;
}
